import { useIntl } from 'react-intl'
import moment, { Moment } from 'moment'
import { Dialog } from 'primereact/dialog'
import { LuxButton } from '@lux/wardrobe-lib'
import './DialogEventOverlapVisit.scss'
import { useState } from 'react'

const DialogEventOverlapVisit = (props: {
    dialogVisible: boolean
    startDate: Moment
    existingEventName: string
    alternativeSlots: number[]
    onHide: () => void
    onConfirm: (slot: number) => void
}) => {
    const { dialogVisible, startDate, existingEventName, alternativeSlots, onHide, onConfirm } =
        props

    const componentClass = 'smart-modals-dialog-event-overlap-visit'

    const [selectedSlot, setSelectedSlot] = useState<number>(null)

    const intl = useIntl()

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={onConfirm.bind(null, selectedSlot)}
                    text={intl.formatMessage({
                        id: 'modals.activity.visit.event.overlap.replace',
                        defaultMessage: 'Replace Event',
                    })}
                    variant="outlined"
                    disabled={!selectedSlot}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.activity.visit.event.overlap',
                defaultMessage: 'Event Overlap',
            })}
            draggable={false}
            visible={dialogVisible}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}
            onHide={() => onHide()}
            footer={renderFooter}>
            <div>
                <div className={`${componentClass}-description text-bold`}>
                    {intl.formatMessage(
                        {
                            id: 'modals.activity.visit.event.overlap.description',
                            defaultMessage: `There is already an event on ${startDate.format(
                                'L'
                            )} at ${startDate.format('HH')}:${startDate.format('mm')}.`,
                        },
                        {
                            date: startDate.format('L'),
                            hours: startDate.format('HH'),
                            minutes: startDate.format('mm'),
                        }
                    )}
                </div>
                <div className={`${componentClass}-description text`}>{existingEventName}</div>
                <div className={`${componentClass}-description text-bold`}>
                    {intl.formatMessage({
                        id: 'modals.activity.visit.event.overlap.more.slots',
                        defaultMessage: 'More slots avaiable',
                    })}
                </div>
                <div className={`${componentClass}-description select text`}>
                    {intl.formatMessage({
                        id: 'modals.activity.visit.event.overlap.select',
                        defaultMessage: 'Select to replace the event',
                    })}
                </div>
                {alternativeSlots.map((slot) => {
                    const date = moment(slot)
                    return (
                        <div
                            className={`${componentClass}-slot text ${
                                selectedSlot === slot ? 'active' : ''
                            }`}
                            onClick={() => setSelectedSlot(slot)}>
                            {date.format('L')}{' '}
                            {intl.formatMessage({
                                id: 'modals.activity.visit.event.overlap.at',
                                defaultMessage: 'at',
                            })}{' '}
                            {date.format('HH')}:{date.format('mm')}
                        </div>
                    )
                })}
            </div>
        </Dialog>
    )
}

export default DialogEventOverlapVisit
